import toast from "react-hot-toast";
import api from "../Crypto/axios.js";

export const FETCH_ALL_CATEGORY = "FETCH_ALL_CATEGORY";
export const ADD_NEW_CATEGORY = "ADD_NEW_CATEGORY";
export const SET_SELECTED_CATEGORY_ROW = "SET_SELECTED_CATEGORY_ROW";
export const RESET_SELECTED_CATEGORY_ROW = "RESET_SELECTED_CATEGORY_ROW";
export const STATUS_UPDATED = "STATUS_UPDATED";
export const CLEAR_DATA = "CLEAR_DATA";

const initialState = {
  allCategory: [],
  newCategory: [],
  selectedCategoryRow: {},
  statusUpdate: {},
};

const CategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ALL_CATEGORY:
      return {
        ...state,
        allCategory: action.payload,
      };
    case ADD_NEW_CATEGORY:
      return {
        ...state,
        newCategory: action.payload,
      };
    case SET_SELECTED_CATEGORY_ROW:
      return {
        ...state,
        selectedCategoryRow: action.payload,
      };
    case RESET_SELECTED_CATEGORY_ROW:
      return {
        ...state,
        selectedCategoryRow: {},
      };
    case STATUS_UPDATED:
      return {
        ...state,
        statusUpdate: {},
      };
    case CLEAR_DATA:
      return {
        ...state,
        allCategory: [],
        error: null,
      };
    default:
      return state;
  }
};

export default CategoryReducer;

export const fetchAllCategory = (data) => ({
  type: FETCH_ALL_CATEGORY,
  payload: data,
});
export const addCategory = (data) => ({
  type: ADD_NEW_CATEGORY,
  payload: data,
});
export const clearData = () => ({
  type: CLEAR_DATA,
});
export const setSelectedCategoryRow = (data) => ({
  type: SET_SELECTED_CATEGORY_ROW,
  payload: data,
});
export const resetSelectedCategoryRow = () => ({
  type: RESET_SELECTED_CATEGORY_ROW,
});
export const statusUpdate = (data) => ({
  type: STATUS_UPDATED,
});

export const getAllCategory = (userId) => {
  return async (dispatch) => {
    try {
      let response = '';

      if (userId) {
        response = await api.get(`/nrcb/ecom/get/category/${userId}`);
      } else {
        response = await api.get('/nrcb/ecom/get/category', {
          requiresAuth: true,
        });
      }

      if (!response) {
        dispatch(clearData());
        throw new Error('Failed to fetch categories');
      }

      dispatch(fetchAllCategory(response));
      return response;
    } catch (error) {
      console.error('Failed to fetch category:', error);
      throw error;
    }
  };
};

export const addNewCategory = (adminId, newCategory) => {
  return async (dispatch) => {
    const promise = api
      .post(`/nrcb/ecom/add/category/${adminId}`, newCategory, {
        requiresAuth: true,
      })
      .then((response) => {
        dispatch(addCategory(response));
        return response;
      });

    toast.promise(promise, {
      loading: 'Adding New Category...',
      success: 'New Category Added',
      error: (error) => {
        console.error('Failed to add category:', error);
        return error.response?.data?.message || 'Failed to add Category';
      },
    });

    return promise.catch(() => {
      return { status: 'error', message: 'Failed to add category' };
    });
  };
};

export const editCategory = (adminId, categoryData) => {
  return async (dispatch) => {
    const promise = api
      .post(`/nrcb/ecom/edit/category/${adminId}`, categoryData, {
        requiresAuth: true,
      })
      .then((response) => {
        dispatch(addCategory(response));
        dispatch(resetSelectedCategoryRow());
        return response;
      });

    toast.promise(promise, {
      loading: 'Editing data...',
      success: 'Successfully Edited',
      error: (error) => {
        console.error('Failed to edit category:', error);
        return error.response?.data?.message || 'Failed to edit data';
      },
    });

    return promise.catch(() => {
      return { status: 'error', message: 'Failed to edit data' };
    });
  };
};

export const statusCategory = (data, adminId) => {
  return async (dispatch) => {
    const promise = api
      .post(`/nrcb/ecom/status/category/${adminId}`, data, { requiresAuth: true })
      .then((response) => {
        dispatch(statusUpdate(response));
        dispatch(resetSelectedCategoryRow());
        return response;
      });

    toast.promise(promise, {
      loading: "Processing...",
      success: (res) => `Category: ${res?.message}`,
      error: (error) => {
        console.error("Failed to update category status:", error);
        return error.response?.data?.message || "Failed";
      },
    });

    return promise.catch(() => {
      return { status: "error", message: "Failed to update category status" };
    });
  };
};

